import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import Assets from './Assets.js';
import Dressing from './Dressing.js';
import Raycaster from './Raycaster.js';

export default class World {
  constructor() {
    // Variables
    this.sizes = null;
    this.canvas = document.getElementById('webgl');
    this.scene = new THREE.Scene();
    this.camera;
    this.renderer;

    // Setup
    this.assets = new Assets(this);
    this.dressing = new Dressing();
    this.dressing.scene = this.scene;
    this.ground;

    this.setCamera();
    // console.log(this.canvas);
    this.setOrbitControl();
    this.setRenderer();
    this.setLights();
    this.setGround();
    this.setLogo();
    this.raycaster = new Raycaster();
    this.raycaster.setEvents(this);

    // Loop
    const tick = () => {
      // Render
      this.renderer.render(this.scene, this.camera);

      // Control
      this.orbitControl.update();

      // Raycast
      this.raycaster.update();

      // Loop
      window.requestAnimationFrame(tick);
    };
    tick();

    // Resize
    window.addEventListener('resize', () => {
      this.resize();
    });

    this.resize();
  }

  setCamera() {
    this.camera = new THREE.PerspectiveCamera(75, 0, 0.01, -1);
    this.camera.position.set(2, 2, 6);

    this.scene.add(this.camera);
  }

  setOrbitControl() {
    this.orbitControl = new OrbitControls(this.camera, this.canvas);
    this.orbitControl.enableDamping = true;
    this.orbitControl.screenSpacePanning = false;
    //this.orbitControl.enablePan = false;

    this.orbitControl.maxDistance = 50;
    this.orbitControl.target = new THREE.Vector3(2, 0, 0);
  }

  setRenderer() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
    });

    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFShadowMap;

    this.renderer.setClearColor(0xf3f4f6, 1);
  }

  setLights() {
    // Spot
    const positions = [
      {
        position: new THREE.Vector3(10, 10, 5),
        strenght: 1,
      },
      {
        position: new THREE.Vector3(10, 5, -8),
        strenght: 0.3,
      },
    ];

    for (const position of positions) {
      const spotLight = new THREE.DirectionalLight(0xffffff, position.strenght);

      spotLight.position.copy(position.position);
      spotLight.castShadow = true;
      spotLight.shadow.normalBias = 0.02;

      spotLight.shadow.mapSize.width = 1024;
      spotLight.shadow.mapSize.height = 1024;

      this.scene.add(spotLight);
    }

    const ambientLight = new THREE.AmbientLight(0xffffff, 1);
    this.scene.add(ambientLight);
  }

  setGround() {
    this.ground = new THREE.Mesh(
      new THREE.PlaneGeometry(30, 30),
      new THREE.MeshStandardMaterial({
        map: this.assets.grounds[0].map,
      }),
    );
    this.ground.receiveShadow = true;
    this.ground.rotation.x = -Math.PI * 0.5;

    this.scene.add(this.ground);
  }

  setLogo() {
    const logo = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 0.35),
      new THREE.MeshBasicMaterial({
        map: this.assets.logo,
        transparent: true,
        side: THREE.DoubleSide,
      }),
    );

    logo.position.set(0.5, 0.175, 2);
    this.scene.add(logo);
  }

  setGroundColor(map) {
    this.ground.material.map = map;
  }

  resize() {
    const innerHeight = window.innerHeight;
    const innerWidth = window.innerWidth;

    const headerSize = 91; // The website header is 75px tall + 1rem/16px bottom margin

    this.sizes = {
      height: innerHeight > innerWidth ? (innerHeight - headerSize) / 2 : innerHeight - headerSize,
      width: innerWidth > innerHeight ? innerWidth / 2 : innerWidth,
    };
    //console.log(this.sizes.height);

    // Update renderer
    this.renderer.setSize(this.sizes.width, this.sizes.height, false);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // Update camera
    this.camera.aspect = this.sizes.width / this.sizes.height;
    this.camera.updateProjectionMatrix();

    this.sizes.box = this.canvas.getBoundingClientRect();
  }
}
